<template>

  <div class="g-2 mb-2 vh-100">
    <nav class="navbar-nav mx-auto my-5">
      <router-link to="/" class="align-self-center">
        <img
          src="@/assets/img/logo.png"
          alt="Porto Admin"
          class="d-block w-75 text-center mx-auto"
        />
      </router-link>
    </nav>

    <div class="mx-5">
      <div class="bg-white rounded-4 rounded-bottom-0">
        <div class="container ">
          <div class="d-flex justify-content-evenly pt-4 pb-4">
            <div>
              <div class="py-4">
                <img
                  src="@/assets/img/toilet_female.png"
                  alt=""
                  width="220"
                  class="d-block mx-auto"
                />
              </div>
              <div class="text-center">
                <p class=" font-weight-bold color-female fs-7 mb-0">
                  {{ organizedData.female.available }}
                </p>
              </div>
            </div>
            <div
              class="text-center d-flex flex-column justify-content-center align-items-center"
            >
              <h3 class="font-weight-normal fs-1 letter-spacing-1">
                都歷遊客中心
                {{ CONST.HUMAN_SENSOR_TYPE.FLOOR[parseInt(place) - 1] }}
              </h3>
              <div class=" mt-5 mb-2 font-weight-bold fs-10 letter-spacing-1">可使用</div>
              <div class="mt-3 font-weight-bolder fs-10">Vacant</div>
            </div>
            <div>
              <div class="py-4">
                <img
                  src="@/assets/img/toilet_male.png"
                  alt=""
                  width="220"
                  class="d-block mx-auto"
                />
              </div>
              <div class="text-center ">
                <p class="font-weight-bold color-male fs-7 mb-0">
                  {{ organizedData.male.available }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <div class="bg-female rounded-bottom-left-4 col-6">
          <div class="container">
              <div v-if="organizedData.female && organizedData.female.types" class="text-white d-flex justify-content-evenly">
                <div v-for="(item, i) in organizedData.female.types" :key="i">
                  <div class="block-1 d-flex align-items-center mt-5">
                    <img
                      alt=""
                      :src="toiletTypeImg(i)"
                      :height="toiletTypeImgHeight(i)"
                      class="mx-auto d-block shadow-img"
                    />
                  </div>
                  <div class="text-center text-white">
                    <div class=" font-weight-bold text-white fs-8 lh-base">
                      {{ item.available }}
                    </div>
                  </div>
              </div>
            </div>
            </div>
        </div>
        <div class="bg-male rounded-bottom-right-4 col-6">
          <div class="container">
            <div class="text-white d-flex justify-content-evenly"  v-if="organizedData.male && organizedData.male.types">
                <div v-for="(item, i) in organizedData.male.types" :key="i">
                  <div class="block-1 d-flex align-items-center mt-5">
                    <img
                      :src="toiletTypeImg(i)"
                      :height="toiletTypeImgHeight(i)"
                      class="mx-auto d-block shadow-img"
                    />
                  </div>
                  <div class="text-center text-white">
                    <div class="fs-8 font-weight-bold text-white lh-base">
                      {{ item.available }}
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    
    <div class="d-flex mx-5 my-4  align-items-stretch justify-content-between">
      <div class="col-5  h-100" v-if="organizedData.accessible">
        <div class="rounded-4 bg-accessible py-1 me-4">
          <div>
            <div class="py-5 mx-auto">
              <img
                src="@/assets/img/toilet_wheelchair.png"
                alt=""
                width="160"
                class="d-block mx-auto mb-5"
              />
              <img
                src="@/assets/img/toilet_family.png"
                width="160"
                alt=""
                class="d-block mx-auto"
              />
            </div>
            <div
              class="text-center rounded-4 bg-white mx-3 my-3 py-5"
              v-if="organizedData.accessible.available === 0"
            >
              <div class="fs-9 font-weight-bold color-female mb-4">使用中</div>
              <p class="fs-1 font-weight-bold color-female mb-0">In Use</p>
            </div>
            <div class="text-center rounded-4 bg-white mx-3 my-3 py-5" v-else>
              <div class="fs-9 font-weight-bold color-dark-green mb-4">可使用</div>
              <p class="fs-1 font-weight-bold color-dark-green mb-0">
                Available
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="col-7 align-self-stretch">
        <div
          class="rounded-4 bg-memo py-1  text-black font-weight-bold h-100"
        >
          <div class="mx-4 mt-5">
            <div class="fs-1 text-memo mb-3 ms-3 letter-spacing-1">
              {{CONST.HUMAN_SENSOR_MONITOR_TEXT[parseInt(place) - 1].TAIWANESE}}
             </div>
            <ul class="px-4 text-memo">
              <li>
                <p class="text-memo fs-1">
                  {{CONST.HUMAN_SENSOR_MONITOR_TEXT[parseInt(place) - 1].ENGLISH}}
                </p>
              </li>
              <li>
                <p class="text-memo fs-1">
                  {{CONST.HUMAN_SENSOR_MONITOR_TEXT[parseInt(place) - 1].JAPANESE}}
                </p>
              </li>
              <li>
                <p class="text-memo fs-1"> {{CONST.HUMAN_SENSOR_MONITOR_TEXT[parseInt(place) - 1].KOREAN}}</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- 測試用區塊 -->
    <div class="test-block ">
      <div >
        系統
        <br/>
        測試中
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import scenicArea from "../../store/modules/eastCoastDataApi/scenicArea";

export default {
  components: {},

  data() {
    return {
      CONST: CONST,
      scenicAreaId: this.$route.params.id,
      place: this.$route.params.floor,
      filterData: [],
      organizedData: [],
      testHumanSensorData: [
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE12",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00001",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "female",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE14",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心女廁",
          publicPlaceId: 178,
          deviceId: "hm00003",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "female",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE14",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心女廁",
          publicPlaceId: 178,
          deviceId: "hm00003",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "mixed",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE13",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心親子廁",
          publicPlaceId: 21,
          deviceId: "hm00004",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "mixed",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE13",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "阿美民俗中心親子廁",
          publicPlaceId: 21,
          deviceId: "hm00004",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE15",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00005",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "1F",
          gender: "male",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "male",
          inUse: true,
          toiletType: "sit",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "male",
          inUse: false,
          toiletType: "sit",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場男廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "female",
          inUse: false,
          toiletType: "squat",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場女廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
        {
          floor: "2F",
          gender: "female",
          inUse: true,
          toiletType: "sit",
          identifierSetting: "DE16",
          scenicAreaName: "都歷遊客中心",
          scenicAreaId: 0,
          publicPlaceName: "大停車場女廁",
          publicPlaceId: 174,
          deviceId: "hm00006",
          deviceName: "廁間人體偵測",
          ip: "",
        },
      ],
      dataInterval: null,
      dataInterval2: null,
    };
  },
  created() {
    this.getHumanSensor();
  },
  methods: {
    async getHumanSensor() {
      const condition = {
        areaId: this.scenicAreaId,
      };
      await this.$store.dispatch("humanSensor/getHumanSensor", condition);
    },

    toiletTypeImg(type) {
      return require(`@/assets/img/toilet_${type}.svg`);
    },

    toiletTypeImgHeight(type) {
      if (type === "squat") {
        return 50;
      } else if (type === "sit") {
        return 120;
      }
    },

    organizeToilets(data) {
      const result = {};
      data.forEach((item) => {
        const gender = [
          CONST.HUMAN_SENSOR_TYPE.GENDER_FEMALE,
          CONST.HUMAN_SENSOR_TYPE.GENDER_MALE,
        ].includes(item.gender)
          ? item.gender
          : CONST.HUMAN_SENSOR_TYPE.GENDER_OTHER;
        const toiletType = item.toiletType;

        if (!result[gender]) {
          result[gender] = {
            total: 0,
            inUse: 0,
            available: 0,
            types: {},
          };
        }

        if (!result[gender].types[toiletType]) {
          result[gender].types[toiletType] = {
            total: 0,
            inUse: 0,
            available: 0,
            list: [],
          };
        }
        result[gender].types[toiletType].list.push(item);

        // 累加統計
        result[gender].total += 1;
        result[gender].types[toiletType].total += 1;

        if (item.inUse) {
          result[gender].inUse += 1;
          result[gender].types[toiletType].inUse += 1;
        }
      });
      for (const floor in result) {
        for (const gender in result) {
          const genderData = result[gender];
          genderData.available = genderData.total - genderData.inUse;

          for (const toiletType in genderData.types) {
            const typeData = genderData.types[toiletType];
            typeData.available = typeData.total - typeData.inUse;
          }
        }
      }
      console.log("result", result);
      this.organizedData = result;
      // return result;
    },
  },
  computed: {
    // ...mapGetters("humanSensor", { humanSensor: "getHumanSensorData" }),
  },

  watch: {
    humanSensor: {
      async handler(newVal) {
        console.log("this.testHumanSensorData", this.testHumanSensorData);
        if (newVal) {
          this.filterData = this.testHumanSensorData.filter((item) => {
            // this.filterData = newVal.filter((item) => {
            return (
              item.floor ===
              CONST.HUMAN_SENSOR_TYPE.FLOOR[parseInt(this.place) - 1]
            );
          });
          this.organizeToilets(this.filterData);
        }

        // console.log("filterData", this.filterData);
      },

      },
    testHumanSensorData: {
      handler(newVal) {
       if (newVal) {
          this.filterData = this.testHumanSensorData.filter((item) => {
            // this.filterData = newVal.filter((item) => {
            return (
              item.floor ===
              CONST.HUMAN_SENSOR_TYPE.FLOOR[parseInt(this.place) - 1]
            );
          });
          this.organizeToilets(this.filterData);
        }

        // console.log("filterData", this.filterData);
      },
    deep:true
    
    },
  },
  async mounted() {

    this.filterData = this.testHumanSensorData.filter((item) => {
            // this.filterData = newVal.filter((item) => {
            return (
              item.floor ===
              CONST.HUMAN_SENSOR_TYPE.FLOOR[parseInt(this.place) - 1]
            );
          });
          this.organizeToilets(this.filterData);
    this.dataInterval = setInterval(() => {
      this.testHumanSensorData[9].inUse =
        !this.testHumanSensorData[9].inUse;
      console.log("5s")
    }, 15000);

    this.dataInterval2 = setInterval(() => {
      this.testHumanSensorData[3].inUse === 1
        ? (this.testHumanSensorData[3].inUse = 0)
        : (this.testHumanSensorData[3].inUse = 1);
      console.log("5s")
    }, 10000);


  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;

    if (this.dataInterval2) clearInterval(this.dataInterval2);
    this.dataInterval2 = null;
  },
};
</script>

<style lang="scss" scoped>
.block-3 {
  padding: 0 2px;
  height: 80px;
}

.block-type {
  border-radius: 10px;
  background-color: #ededed;

  text-align: center;
  font-size: 1.2rem;
  font-weight: bold;
  color: #f2f2f2;

  min-width: 100px;
}

.rounded-bottom-0 {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-bottom-right-4 {
  border-bottom-right-radius: 1rem;
}

.rounded-bottom-left-4 {
  border-bottom-left-radius: 1rem;
}

.color-female {
  color: #fe8f1d;
}

.bg-female {
  background-color: #f6ab5f;
}

.color-male {
  color: #7D9144;
}

.bg-male {
  background-color: #becd72;
}

.color-accessible {
  color: #0086c9;
}

.color-dark-green{
  color:#7D9144;
}
.bg-accessible {
  background-color: #9dbee1;
}

.block-1 {
  width: 100px;
  height: 120px;
}

.fs-7{
  font-size: 10rem;
  line-height:1.3;
}

.fs-8{
  font-size:7.5rem;
}

.fs-9{
  font-size:3.2rem
}

.fs-10{
  font-size:4.5rem;
}

.letter-spacing-1{
  letter-spacing: 5px;
}

.bg-memo {
  background-color: #bdcee0;
}

.text-memo {
  color: #4f4f4f;
  font-weight: 450;
  line-height: 1.25;
}

.shadow-img {
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.4));
}

.g-style-3{
  gap: 0 10px;
}

.test-block {
  position: fixed;
  top:90px;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  pointer-events: none;
  opacity: 0.6;
}

.test-block > div {
  font-size: 8rem;
  color: rgb(114, 114, 114);
  // transform: rotate(-30deg);
  white-space: nowrap;
  text-align: center;
  line-height: 2;
  letter-spacing: 30px;
}

li::marker {
  font-size: 2em;
}
</style>
